import { connect } from 'react-redux';

import { offersFetcher } from 'redux/fetchers/offers';

import getBaseOffersPageProps from 'components/Offers/utils/get-base-properties';

import OffersPage from 'components/Offers/OffersPage/OffersPage';
import { withRouteProps } from 'utils/with-route-props';

export default withRouteProps(
  connect(getBaseOffersPageProps, (dispatch, props) => ({
    fetchOfferProducts: () => dispatch(offersFetcher(props)),
  }))(OffersPage),
);
